export function imageUrl(value) {
    const raw = String(value || '').trim();
    try {
        const url = new URL(raw);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
        if (url.hostname === 'drive.google.com') {
            const id = url.pathname.match(/^\/file\/d\/([A-Za-z0-9_-]+)/)?.[1] || url.searchParams.get('id');
            if (id && /^[A-Za-z0-9_-]+$/.test(id)) return 'https://drive.google.com/thumbnail?id=' + id + '&sz=w1600';
        }
        return raw;
    } catch { return raw.startsWith('/') && !raw.startsWith('//') ? raw : ''; }
}
